/* import __COLOCATED_TEMPLATE__ from './group-navigation.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./group-navigation.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: ""
}));